export default __webpack_public_path__ + "static/media/amazonBtnDisab.70073b66.png";